import classnames from 'classnames';
import React from 'react';

const CSS = require('./SubNavbar.module.scss');

interface SubNavbarProps {
  transparent?: boolean;
  children: any;
}

function SubNavbar({ transparent, children }: SubNavbarProps) {
  if (!children) {
    return null;
  }

  return (
    <div className={CSS.SubNavbarContainer}>
      <div
        className={classnames(CSS.SubNavbar, {
          [CSS.SubNavbarTransparent]: transparent,
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default SubNavbar;
